export default {
  data() {
    return {};
  },
  methods: {
    validateABN(abn) {
      console.log(abn);
      if (abn.length < 11) return false;

      let data = abn.split("");
      let sumData = (data[0] - 1) * 10;
      let weighting_factor = 1;
      data.forEach((element, index) => {
        if (index > 0) {
          sumData += element * weighting_factor;
          weighting_factor += 2;
        }
      });
      let reminder = sumData % 89;
      if (reminder === 0) return true;
      return false;
    },
    maskABN(abn) {
      return abn.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
  },
};
